import React from 'react';
import Api from '../../Api.js';
import { ModalContainer, ModalDialog } from 'react-modal-dialog';

class Org2OrgCopyPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      custs: [],
      srclocs: [],
      orgs: [],
      dstlocs: [],
      showModal: false,
      showErrorModal: false,
      errorMsg: '',
      cust: '',
      srcOrg: '',
      srcloc: '',
      org: '',
      dstloc: '',
      itemcnt: 0,
      isModifiersIncluded: false,
      isTaxesIncluded: false,
      runningScript: false,
      isPrinterIncluded: false,
    };
  }

  componentDidMount() {
    Api.getOrgList().then((data) => {
      let orgList = data || [];
      let selectData = { name: ' -Select- ', id: '' };
      orgList.splice(0, 0, selectData);
      this.setState({ orgs: orgList, org: orgList[0] });
    });
  }

  componentDidUpdate() {
    if (this.state.srcOrg.id && this.state.srcloc.id && this.state.org.id && this.state.dstloc.id) {
      $('#copyProduct').prop('disabled', false);
      $('#copyProduct').css('background-color', '#0078e7');
    } else {
      $('#copyProduct').prop('disabled', true);
      $('#copyProduct').css('background-color', 'grey');
    }

    if (this.state.srcOrg.id) {
      $('#srclocation').removeAttr('disabled');
    } else {
      $('#srclocation').attr('disabled', 'disabled');
    }

    if (this.state.org.id != '') {
      $('#targeLlocation').removeAttr('disabled');
    } else {
      $('#targeLlocation').attr('disabled', 'disabled');
    }
  }

  handleSrcLocChange(e) {
    let value = e.target.value;
    let filter = this.state.srclocs.filter((srcloc) => {
      return srcloc.id == value;
    });
    let srcloc = filter[0];
    this.setState({ srcloc: srcloc });
    // toggleSubmitButton();
  }

  handleOrgChange(e) {
    let value = e.target.value;
    let id = e.currentTarget.id;

    let filter = this.state.orgs.filter((org) => {
      return org.id == value;
    });
    let org = filter[0];
    Api.getLocationList(org.id)
      .then((data) => {
        let locList = data || [];
        let selectData = { name: ' -Select- ', id: '' };
        locList.splice(0, 0, selectData);
        if (id == 'srcOrg') {
          this.setState({ srclocs: locList, srcloc: locList[0], srcOrg: org });
        } else {
          this.setState({ dstlocs: locList, dstloc: locList[0], org: org });
        }
        if (locList.length <= 0) {
          this.handleShowError('This org has no locations');
        }
      })
      .catch(() => {
        this.handleShowError('Unable to fetch location list from ADM');
      });
  }

  handleDstLocChange(e) {
    let value = e.target.value;
    let filter = this.state.dstlocs.filter((dstloc) => {
      return dstloc.id == value;
    });
    let dstloc = filter[0];
    this.setState({ dstloc: dstloc });
  }

  handleModifiersIncludeChange(e) {
    let tgt = e.target;
    let value = tgt.type === 'checkbox' ? tgt.checked : false;
    this.setState({ isModifiersIncluded: value });
  }

  handleTaxesIncludeChange(e) {
    let tgt = e.target;
    let value = tgt.type === 'checkbox' ? tgt.checked : false;
    this.setState({ isTaxesIncluded: value });
  }

  handlePrinterIncludeChange(e) {
    let tgt = e.target;
    let value = tgt.type === 'checkbox' ? tgt.checked : false;
    this.setState({ isPrinterIncluded: value });
  }

  handleCloseError() {
    this.setState({
      showErrorModal: false,
      errorMsg: '',
    });
  }

  handleShowError(msg) {
    this.setState({
      showErrorModal: true,
      errorMsg: msg,
    });
  }

  handleCloseModal() {
    this.setState({
      showModal: false,
    });
  }

  handleShowModal() {
    console.log(
      this.state.srcloc.id,
      this.state.dstloc.id,
      this.state.isModifiersIncluded,
      this.state.isTaxesIncluded
    );
    Api.getProductCount(this.state.srcloc.id, this.state.srcOrg.id)
      .then((data) => {
        let cnt = data.count || 0;
        if (cnt != '0') {
          this.setState({ itemcnt: cnt, showModal: true });
        } else {
          this.handleShowError('Source Org has 0 Product');
          this.setState({ itemcnt: 0, showModal: false });
        }
      })
      .catch(() => {
        this.setState({ itemcnt: 0, showModal: true });
        // this.handleShowError("Unable to get item count for Source Location")
      });
  }

  handleSubmit() {
    this.handleCloseModal();
    Api.copyProductsFromOrg2Org(
      this.state.srcOrg.id,
      this.state.srcloc.id,
      this.state.org.id,
      this.state.dstloc.id,
      this.state.isModifiersIncluded,
      this.state.isTaxesIncluded,
      this.state.isPrinterIncluded
    )
      .then((data) => {
        let result = data.result || '';
        if (result != 'success') {
          this.handleShowError(result);
        } else {
          window.location.reload(false);
        }
      })
      .catch((e) => {
        this.handleShowError(e.message);
      });
    this.setState({ runningScript: true });
  }

  render() {
    return (
      <div className='content'>
        <div className='pure-form pure-form-horizontal pure-g'>
          <div className='pure-u-1'>
            <div className='pure-u-1-5'></div>
            <div className='pure-u-1-5'>
              <div className='pure-control-group pure-u-1'>
                <label className='pure-u-1' style={{ color: 'gray' }}>
                  Source Org
                </label>
                <select
                  id='srcOrg'
                  className='pure-input-1'
                  style={{ height: '3.6em' }}
                  onChange={this.handleOrgChange.bind(this)}
                >
                  <option value='' disabled selected hidden>
                    - Select -
                  </option>
                  {this.state.orgs.map((org) => (
                    <option key={org.id} value={org.id}>
                      {org.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className='pure-u-1-5'></div>
            <div className='pure-u-1-5'>
              <div className='pure-control-group'>
                <label className='pure-u-1' style={{ color: 'gray' }}>
                  Target Org
                </label>
                <select
                  id='targetOrg'
                  className='pure-input-1'
                  style={{ height: '3.6em' }}
                  onChange={this.handleOrgChange.bind(this)}
                >
                  <option value='' disabled selected hidden>
                    - Select -
                  </option>
                  {this.state.orgs.map((org) => (
                    <option key={org.id} value={org.id}>
                      {org.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className='pure-u-1-5'></div>
          </div>
        </div>

        <div className='pure-form pure-form-horizontal pure-g'>
          <div className='pure-u-1'>
            <div className='pure-u-1-5'></div>
            <div className='pure-u-1-5'>
              <div className='pure-control-group pure-u-1'>
                <label className='pure-u-1' style={{ color: 'gray' }}>
                  Source Location
                </label>
                <select
                  id='srclocation'
                  className='pure-input-1'
                  style={{ height: '3.6em' }}
                  onChange={this.handleSrcLocChange.bind(this)}
                >
                  <option value='' disabled selected hidden>
                    - Select -
                  </option>
                  {this.state.srclocs.map((srclocs) => (
                    <option key={srclocs.id} value={srclocs.id}>
                      {srclocs.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className='pure-u-1-5'></div>
            <div className='pure-u-1-5'>
              <div className='pure-control-group pure-u-1'>
                <label className='pure-u-1' style={{ color: 'gray' }}>
                  Target Location
                </label>
                <select
                  id='targeLlocation'
                  className='pure-input-1'
                  style={{ height: '3.6em' }}
                  onChange={this.handleDstLocChange.bind(this)}
                >
                  <option value='' disabled selected hidden>
                    - Select -
                  </option>
                  {this.state.dstlocs.map((dstloc) => (
                    <option key={dstloc.id} value={dstloc.id}>
                      {dstloc.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className='pure-u-1-5'></div>
          </div>
        </div>

        <div className='pure-form pure-form-horizontal pure-g'>
          <div className='pure-u-1'>
            <div className='pure-u-1-5'></div>
            <div className='pure-u-1-5'>
              <div className='pure-control-group pure-u-1'>
                <label style={{ color: 'gray' }} className='pure-checkbox'>
                  <input
                    type='checkbox'
                    id='isModifiersIncluded'
                    defaultValue=''
                    onClick={this.handleModifiersIncludeChange.bind(this)}
                  />{' '}
                  Include Product Modifiers
                </label>
              </div>
            </div>
            <div className='pure-u-1-5'></div>
            <div className='pure-u-1-5'></div>
            <div className='pure-u-1-5'></div>
          </div>

          <div className='pure-u-1'>
            <div className='pure-u-1-5'></div>
            <div className='pure-u-1-5'>
              <div className='pure-control-group pure-u-1'>
                <label style={{ color: 'gray' }} className='pure-checkbox'>
                  <input
                    type='checkbox'
                    id='isTaxesIncluded'
                    defaultValue=''
                    onClick={this.handleTaxesIncludeChange.bind(this)}
                  />{' '}
                  Include Taxes
                </label>
              </div>
            </div>
            <div className='pure-u-1-5'></div>
            <div className='pure-u-1-5'></div>
            <div className='pure-u-1-5'></div>
          </div>

          <div className='pure-u-1'>
            <div className='pure-u-1-5'></div>
            <div className='pure-u-1-5'>
              <div className='pure-control-group pure-u-1'>
                <label style={{ color: 'gray' }} className='pure-checkbox'>
                  <input
                    type='checkbox'
                    id='isPrinterIncluded'
                    defaultValue=''
                    onClick={this.handlePrinterIncludeChange.bind(this)}
                  />{' '}
                  Include Printers
                </label>
              </div>
            </div>
            <div className='pure-u-1-5'></div>
            <div className='pure-u-1-5'></div>
            <div className='pure-u-1-5'></div>
          </div>
        </div>

        <div className='pure-form pure-form-horizontal pure-g'>
          <div className='pure-control-group pure-u-1'>
            <div className='pure-u-1-4'></div>
            <button
              id='copyProduct'
              onClick={this.handleShowModal.bind(this)}
              style={{ marginTop: '1%', height: '3.6em', backgroundColor: 'grey' }}
              className='pure-button pure-button-primary pure-u-1-2'
            >
              Copy Products
            </button>
            <div className='pure-u-1-4'></div>
          </div>
        </div>

        {this.state.showModal && (
          <ModalContainer>
            <ModalDialog>
              <h1 style={{ textAlign: 'left' }}>Review the product copy details</h1>
              <h2 style={{ textAlign: 'left', fontWeight: 'normal' }}>Summary</h2>
              <ol style={{ listStyleType: 'none' }}>
                <li>
                  <h3 style={{ textAlign: 'left', fontWeight: 'normal' }}>
                    Source Org: <span>{this.state.srcOrg.name}</span>
                  </h3></li>
                <li>
                  <h3 style={{ textAlign: 'left', fontWeight: 'normal' }}>
                    Source Location: <span>{this.state.srcloc.name}</span>
                  </h3></li>
                <li>
                  <h3 style={{ textAlign: 'left', fontWeight: 'normal' }}>
                    Target Org: <span>{this.state.org.name}</span>
                  </h3></li>
                <li>
                  <h3 style={{ textAlign: 'left', fontWeight: 'normal' }}>
                    Target Location: <span>{this.state.dstloc.name}</span>
                  </h3></li>
                <br />
                <li>
                  <h3 style={{ textAlign: 'left', fontWeight: 'normal' }}>
                    Total Products to Copy: <span>{this.state.itemcnt}</span>
                  </h3></li>
                <li>
                  <h3 style={{ textAlign: 'left', fontWeight: 'normal' }}>
                    Include Product Modifiers:{' '}
                    <span>{this.state.isModifiersIncluded ? 'Yes' : 'No'}</span>
                  </h3></li>
                <li>
                  <h3 style={{ textAlign: 'left', fontWeight: 'normal' }}>
                    Include Taxes: <span>{this.state.isTaxesIncluded ? 'Yes' : 'No'}</span>
                  </h3></li>
                <li>
                  <h3 style={{ textAlign: 'left', fontWeight: 'normal' }}>
                    Include Printers: <span>{this.state.isPrinterIncluded ? 'Yes' : 'No'}</span>
                  </h3></li>
              </ol>
              <br />
              <br />
              <h2 style={{ textAlign: 'left', fontWeight: 'normal' }}>Do you want to continue?</h2>
              <button
                className='pure-button pure-u-1-2'
                style={{ width: '100px', borderRadius: '10px' }}
                onClick={this.handleCloseModal.bind(this)}>
                Cancel
              </button>
              &nbsp;&nbsp;&nbsp;
              <button
                className='pure-button pure-button-primary pure-u-1-2'
                style={{ width: '100px', borderRadius: '10px' }}
                onClick={this.handleSubmit.bind(this)}>
                Yes
              </button>
            </ModalDialog>
          </ModalContainer>
        )}
        {this.state.showErrorModal && (
          <ModalDialog>
            <h2 style={{ textAlign: 'left' }}>
              <i className='fa fa-exclamation-circle danger'></i> Error(s) Found
            </h2>
            <h3 style={{ textAlign: 'left' }}>The following errors were found</h3>
            <div style={{ textAlign: 'left' }}>{this.state.errorMsg}</div>
            <br />
            <br />
            <button
              className='pure-button pure-u-1-2'
              style={{ width: '100px', borderRadius: '10px', float: 'right' }}
              onClick={this.handleCloseError.bind(this)}
            >
              Close
            </button>
          </ModalDialog>
        )}
      </div>
    );
  }
}

export default Org2OrgCopyPage;



// WEBPACK FOOTER //
// ./src/components/pages/Org2OrgCopyPage.js